// @noflow
export type { Props as CustomerProps } from './Person'
export { default as Customer } from './Person'
